const honda = {
  state: () => ({
    images: {
      sedans: [
        {
          modelName: "Accord",
          sideView: require("../../../static/images/carcuts/honda/side-view/accord21.png"),
          angleView: require("../../../static/images/carcuts/honda/angle-view/hondaaccord.png"),
          trims: ["LX", "Sport", "Sport Special Edition", "EX-L", "Touring"]
        },
        {
          modelName: "Civic",
          sideView: require("../../../static/images/carcuts/honda/side-view/civic21.png"),
          angleView: require("../../../static/images/carcuts/honda/angle-view/hondacivic.png"),
          trims: ["LX", "EX", "Sport", "Touring"]
        },
        {
          modelName: "Fit",
          sideView: require("../../../static/images/carcuts/honda/side-view/fit20.png"),
          angleView: require("../../../static/images/carcuts/honda/angle-view/hondafit.png"),
          trims: ["DX", "LX", "Sport", "EX", "EX-L Navi"]
        },
        {
          modelName: "Insight",
          sideView: require("../../../static/images/carcuts/honda/side-view/insight19.png"),
          angleView: require("../../../static/images/carcuts/honda/angle-view/hondainsight.png"),
          trims: ["LX","EX", "Touring"]
        },
      ],
      suvs: [
        {
          modelName: "CR-V",
          sideView: require("../../../static/images/carcuts/honda/side-view/crv20.png"),
          angleView: require("../../../static/images/carcuts/honda/angle-view/hondacrv.png"),
          trims: ["LX", "EX", "EX-L", "Touring"]
        },
        {
          modelName: "HR-V",
          sideView: require("../../../static/images/carcuts/honda/side-view/hrv2021.png"),
          angleView: require("../../../static/images/carcuts/honda/angle-view/hondahrv.png"),
          trims: ["LX", "Sport", "EX", "EX-L", "Touring"]
        },
        {
          modelName: "Passport",
          sideView: require("../../../static/images/carcuts/honda/side-view/passport21.png"),
          angleView: require("../../../static/images/carcuts/honda/angle-view/hondapassport.png"),
          trims: ["Sport", "EX-L", "Touring", "Elite"]
        },
        {
          modelName: "Odyssey",
          sideView: require("../../../static/images/carcuts/honda/side-view/odyssey19.png"),
          angleView: require("../../../static/images/carcuts/honda/angle-view/hondaodyssey.png"),
          trims: ["LX", "EX", "EX-L", "Touring", "Elite"]
        },
        {
          modelName: "Pilot",
          sideView: require("../../../static/images/carcuts/honda/side-view/pilot21.png"),
          angleView: require("../../../static/images/carcuts/honda/angle-view/hondapilot.png"),
          trims: ["LX", "EX", "EX-L", "Special Edition", "Touring", "Elite", "Black Edition"]
        },
      ],
      trucks: [
        {
          modelName: "Ridgeline",
          sideView: require("../../../static/images/carcuts/honda/side-view/ridgeline22.png"),
          angleView: require("../../../static/images/carcuts/honda/angle-view/hondaridgeline.png"),
          trims: ["Sport", "RTL", "RTL-E", "Black Edition"]
        },
      ],
      lifestyleImages: {
        defaultImage: require("../../../static/images/carcuts/honda/lifestyle/accords-hybridandsedan-21.png"),
        sedanImage: require("../../../static/images/carcuts/honda/lifestyle/civic-hatchback-22.png"),
        suvImage: require("../../../static/images/carcuts/honda/lifestyle/CRV21.jpg"),
        truckImage: require("../../../static/images/carcuts/honda/lifestyle/ridgeline-21.png")
      },
      videoLink: ["https://player.vimeo.com/progressive_redirect/playback/191678166/rendition/1080p/file.mp4?loc=external&signature=d09ebe77b7113ff9999523a5a7976443b9d50e8c6fc4b14880c368f4614fae6b"],
      roundButtons: [
        require("../../../static/images/buttons/round-buttons/honda-New.png"), require("../../../static/images/buttons/round-buttons/honda-Used.png"), require("../../../static/images/buttons/round-buttons/honda-ScheduleService.png"), require("../../../static/images/buttons/round-buttons/honda-Worth.png")
      ],
      browseButtons: [
        require("../../../static/images/buttons/browse-buttons/black-new.png"), require("../../../static/images/buttons/browse-buttons/black-used.png"), require("../../../static/images/buttons/browse-buttons/black-service.png"), require("../../../static/images/buttons/browse-buttons/black-specials.png")
      ],
      swoopIcons: [
        require("../../../static/images/buttons/swoop-icons/honda01.png"), require("../../../static/images/buttons/swoop-icons/honda03.png"), require("../../../static/images/buttons/swoop-icons/honda02.png")
      ],
      homeBanners: [
        require("../../../static/images/banners/honda/CM-SL-24-Honda-Established.jpg"), require("../../../static/images/banners/honda/CM-SL-24-Honda-Lifestyle.jpg"), require("../../../static/images/banners/honda/CM-SL-24-Honda-Modern.jpg"), require("../../../static/images/banners/honda/CM-SL-24-Honda-Playful.jpg")
      ],
      stripBanners: [
        require("../../../static/images/banners/honda/SOKAL-SRS-120921-Clarity-Established.jpeg"), require("../../../static/images/banners/honda/SOKAL-SRS-120921-Clarity-Lifestyle.jpeg"), require("../../../static/images/banners/honda/SOKAL-SRS-120921-Clarity-Modern.jpeg"), require("../../../static/images/banners/honda/SOKAL-SRS-120921-Clarity-Playful.jpeg")
      ],
      logoExample: [
        require("../../../static/images/buttons/logos/dd-logo-honda2.png"),
        require("../../../static/images/buttons/logos/dd-logo-honda-w.png")
      ]
    },
   colors: {
      "--primary-color": "#007cc3",
      "--primary-dark": "#000",
      "--primary-light": "#fff",
      "--secondary-color": "#237cc2",
      "--secondary-dark": "#7f8083",
      "--secondary-light": "#c3c4c6"
    },
    fonts: {
      "--heading-text": "'Avenir', 'Avenir Next', 'Helvetica Neue', Arial, sans-serif",
      "--subheading-text": "'Avenir', 'Avenir Next', 'Helvetica Neue', Arial, sans-serif",
      "--body-text": "'Avenir', 'Avenir Next', 'Helvetica Neue', Arial, sans-serif",
      "--bold-text": "'Avenir', 'Avenir Next', 'Helvetica Neue', Arial, sans-serif"
    }
  })
}


export default honda